module.exports = __webpack_public_path__ + "f173e50ec2ecc016d649ebb18c0a6e97.svg";